/**
 * @format
 */

/* eslint-disable @typescript-eslint/explicit-module-boundary-types*/

import * as React from 'react';
//@ts-ignore
import { StyleSheet, View, FlatList, InteractionManager, Platform } from 'react-native';
import Images from '../images';
//@ts-ignore
import { observer } from 'mobx-react';
import TopNavigationBar, { TopNavigationBarPlaceholder } from '../components/TopNavigationBar';
//@ts-ignore
import {
  JDScrollTabView,
  JDDevice,
  JDText,
  JDNativeSystem,
  JDImage,
  JDTouchable,
  JDRouter,
  JDLoadingView,
} from '@jdreact/jdreact-core-lib';
//@ts-ignore
import LinearGradient from '@jdreact/jdreact-core-linear-gradient';
import Radio from '../components/Radio';
import TabConEmpty from '../components/TabConEmpty';
import PropTypes from 'prop-types';
import store from '../services/addGoodsContrastStore/store';
import { logClick, ContrastAdd, ContrastAddExpo, ContrastTab } from '../mta/MtaService';
import { goodsItem } from '../services/addGoodsContrastStore/domain';
const { ScrollTabView, DefaultTabBar } = JDScrollTabView;
const { getRpx } = JDDevice;
const styles = StyleSheet.create({
  wrap: {
    flex: 1,
    backgroundColor: '#fff',
    paddingBottom: JDNativeSystem.isIPhoneX ? getRpx(164) : getRpx(100),
  },
  tab: {
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: getRpx(120),
    height: getRpx(98),
  },
  tabText: {
    height: getRpx(35),
    marginTop: getRpx(6),
    marginBottom: getRpx(6),
    lineHeight: getRpx(35),
    fontSize: getRpx(28),
    color: '#262626',
  },
  current: {
    fontWeight: 'bold',
  },
  curIcon: {
    width: getRpx(52),
    height: getRpx(6),
    position: 'absolute',
    bottom: -getRpx(15),
    left: 0,
    marginLeft: -getRpx(26),
  },

  warpper: {
    flex: 1,
  },

  goodsList: {
    width: getRpx(750),
    height: '100%',
    paddingLeft: getRpx(36),
    paddingRight: getRpx(36),
    paddingTop: getRpx(8),
  },
  goodsItem: {
    flexDirection: 'row',
    alignItems: 'center',
    width: getRpx(750),
    height: getRpx(160),
    marginBottom: getRpx(48),
  },
  goodsFace: {
    width: getRpx(160),
    height: getRpx(160),
    justifyContent: 'center',
    alignItems: 'center',
    elevation: 4,
    shadowOffset: {
      width: 0,
      height: getRpx(4),
    },
    shadowColor: '#000000',
    shadowOpacity: 0.06,
    shadowRadius: getRpx(12),
    backgroundColor: '#fff',
    borderRadius: getRpx(8),
  },
  SoldOutImage: {
    width: getRpx(110),
    height: getRpx(110),
  },
  goodsFaceImage: {
    width: getRpx(140),
    height: getRpx(140),
    resizeMode: 'cover',
  },
  goodsInfo: {
    flexDirection: 'column',
    width: getRpx(430),
    height: getRpx(160),
    marginLeft: Platform.OS === 'android' ? getRpx(20) : getRpx(24),
  },
  goodsName: {
    fontSize: getRpx(26),
    lineHeight: getRpx(37),
    marginBottom: getRpx(43),
    color: '#262626',
  },
  goodsNameColor: {
    color: '#bfbfbf',
  },
  soldOutMask: {
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    top: getRpx(10),
    left: getRpx(10),
    zIndex: 1,
    width: getRpx(140),
    height: getRpx(140),
    backgroundColor: 'rgba(255,255,255,0.6)',
  },
  soldOutColor: {
    color: '#BFBFBF',
  },
  goodsPrice: {
    flexDirection: 'row',
    alignItems: 'flex-end',
  },
  goodsPriceType: {
    fontSize: getRpx(24),
    height: getRpx(30),
    alignItems: 'flex-end',
    fontWeight: 'bold',
  },
  goodsPriceNum: {
    fontSize: getRpx(36),
    alignItems: 'flex-end',
    fontWeight: 'bold',
    height: getRpx(45),
  },
  goodsPriceColor: {
    color: '#F2270C',
    alignItems: 'flex-end',
  },
  addBtn: {
    position: 'absolute',
    bottom: JDNativeSystem.isIPhoneX ? getRpx(100) : getRpx(48),
    left: '50%',
    marginLeft: -getRpx(339),
    width: getRpx(678),
    height: getRpx(76),
    borderRadius: getRpx(42),
  },
  addBtnBox: {
    height: getRpx(76),
    justifyContent: 'center',
    alignItems: 'center',
  },
  addBtnText: {
    fontSize: getRpx(30),
    fontWeight: 'bold',
    color: '#ffffff',
  },
  radio: {
    marginRight: getRpx(11),
  },
  goodsShadow: {
    width: getRpx(160),
    height: getRpx(170),
    position: 'absolute',
    top: 0,
    left: 0,
  },
  loading: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    top: 0,
    left: 0,
    width: getRpx(750),
    height: '100%',
    backgroundColor: '#ffffff',
  },
  pt10: {
    paddingTop: getRpx(10),
  },
});
interface IStoreProps {
  store: {};
}
interface IProps extends IStoreProps {
  store: {
    entrySku: string;
    myFollow: goodsItem[];
    addGoods: goodsItem | null;
    myCart: goodsItem[];
    myRecord: goodsItem[];
    cartLoading: boolean;
    followLoading: boolean;
    showCartIcon: boolean;
    showRecordIcon: boolean;
    showFollowIcon: boolean;
    isLoadAll: boolean;
    isLoadRecordAll: boolean;
    clearCache: () => void;
    handleCheck: (item: goodsItem) => {};
    loadRecordData: (cateId: string) => void;
    loadMoreRecordData: (cateId: string) => void;
    loadCartData: (cateId: string) => void;
    loadFollowData: (cateId: string) => void;
    loadMoreFollowData: (cateId: string) => void;
  };
  cateId: string;
}
interface state {
  loadCartState: boolean;
  loadFollowState: boolean;
}
const { NavigationBar } = JDRouter;
class AddGoodsContrastPage extends React.Component<IProps, state> {
  static checkedLock = false;
  static contextTypes = {
    router: (PropTypes as any).object,
  };
  constructor(props: IProps) {
    super(props);
    this.state = {
      loadCartState: false,
      loadFollowState: false,
    };
    this.onChangeTab = this.onChangeTab.bind(this);
    this.handleCheck = this.handleCheck.bind(this);
    this._loadCartData = this._loadCartData.bind(this);
    this._loadFollowData = this._loadFollowData.bind(this);
  }
  componentDidMount() {
    const {
      store: { entrySku },
      cateId,
    } = this.props;
    store.loadRecordData(cateId);
    //埋点曝光 点击上报
    logClick({
      event_id: ContrastAddExpo,
      event_param: '',
      page_param: entrySku,
    });
  }
  componentWillUnmount() {
    this.props.store.clearCache();
  }
  onChangeTab = ({ i }: any) => {
    const {
      store: { myFollow, myCart, myRecord, entrySku },
      cateId,
    } = this.props;
    // 1 - 对比历史 / 2 - 购物车 / 3 - 我的关注;
    //埋点tab
    logClick({
      event_id: ContrastTab,
      event_param: (i + 1).toString(),
      page_param: entrySku,
    });

    if (i == 0 && myRecord.length == 0) {
      store.loadRecordData(cateId);
    }

    if (i == 1 && myCart.length == 0) {
      store.loadCartData(cateId);
    }
    if (i == 2 && myFollow.length == 0) {
      store.loadFollowData(cateId);
    }
  };

  handleCheck(item: goodsItem) {
    const { store } = this.props;
    InteractionManager.runAfterInteractions(() => {
      store.handleCheck(item);
    });
  }
  //购物车无分页
  _loadCartData() {
    const { loadCartState } = this.state;
    if (loadCartState) {
      return;
    }

    this.setState({
      loadCartState: true,
    });
    //loading data
  }
  //我的关注有分页
  //上拉加载更多
  _loadRecordData = () => {
    const { store, cateId } = this.props;
    store.loadMoreRecordData(cateId);
  };
  _loadFollowData() {
    const { store, cateId } = this.props;
    store.loadMoreFollowData(cateId);
  }
  handleCartEmpty = () => {
    const { store, cateId } = this.props;
    store.loadCartData(cateId);
  };
  handleRecordEmpty = () => {
    const { store, cateId } = this.props;
    store.loadRecordData(cateId);
  };
  handleFollowEmpty = () => {
    const { store, cateId } = this.props;

    store.loadFollowData(cateId);
  };
  renderSoldOut(soldOutFlag: boolean, stockState: string) {
    if (soldOutFlag) {
      return (
        <View style={styles.soldOutMask}>
          <JDImage source={Images.addContrast.removeShelves} style={styles.SoldOutImage}></JDImage>
        </View>
      );
    } else if (!soldOutFlag && stockState == '34') {
      return (
        <View style={styles.soldOutMask}>
          <JDImage source={Images.addContrast.soldOutNoGoods} style={styles.SoldOutImage}></JDImage>
        </View>
      );
    } else {
      return null;
    }
  }
  addGoods = () => {
    const {
      store: { addGoods, entrySku },
      cateId,
    } = this.props;
    if (!addGoods) {
      return;
    }
    store.handleAddGoods(
      cateId,
      this.context.router.toGoodsContrast({
        refresh: true,
      })
    );
    logClick({
      event_id: ContrastAdd,
      event_param: '',
      page_param: entrySku,
    });
  };
  _ListFooterComponent = () => {
    const {
      store: { isLoadAll },
    } = this.props;
    if (isLoadAll) {
    } else {
    }
    return (
      <View style={{ width: getRpx(750), flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
        <JDLoadingView style={{ width: getRpx(40), height: getRpx(40) }}></JDLoadingView>
        <JDText style={{ color: '#bfbfbf', fontSize: getRpx(20), marginLeft: getRpx(10) }}>加载中...</JDText>
      </View>
    );
  };
  _renderItem = ({ item, index }: any) => (
    <JDTouchable onPress={this.handleCheck.bind(this, item)}>
      <View style={index == 0 ? [styles.goodsItem, styles.pt10] : styles.goodsItem}>
        <View style={styles.radio}>
          <Radio checked={item.checked} disabled={item.disabled}></Radio>
        </View>
        <View style={styles.goodsFace}>
          {/* <ImageBackground
                          source={Images.contrast.goodsShadow}
                          style={styles.goodsShadow}
                        ></ImageBackground> */}
          {this.renderSoldOut(item.soldOutFlag, item.stockState)}
          <JDImage
            source={{
              uri: item.skuIcon,
            }}
            style={styles.goodsFaceImage}
          ></JDImage>
        </View>
        <View style={styles.goodsInfo}>
          <JDText
            style={item.disabled ? [styles.goodsName, styles.goodsNameColor] : styles.goodsName}
            numberOfLines={2}
          >
            {item.skuName}
          </JDText>
          <View style={styles.goodsPrice}>
            {item.skuPrice && item.skuPrice.indexOf('.') != -1 ? (
              <>
                <JDText
                  style={
                    item.disabled
                      ? [styles.goodsPriceType, styles.soldOutColor]
                      : [styles.goodsPriceType, styles.goodsPriceColor]
                  }
                >
                  ¥
                </JDText>
                <JDText
                  style={
                    item.disabled
                      ? [styles.goodsPriceNum, styles.soldOutColor]
                      : [styles.goodsPriceNum, styles.goodsPriceColor]
                  }
                >{`${item.skuPrice.substring(1).split('.')[0]}`}</JDText>
                <JDText
                  style={
                    item.disabled
                      ? [styles.goodsPriceType, styles.soldOutColor]
                      : [styles.goodsPriceType, styles.goodsPriceColor]
                  }
                >
                  .{`${item.skuPrice.substring(0).split('.')[1]}`}
                </JDText>
              </>
            ) : (
              <>
                <JDText
                  style={
                    item.disabled
                      ? [styles.goodsPriceType, styles.soldOutColor]
                      : [styles.goodsPriceType, styles.goodsPriceColor]
                  }
                >
                  ¥
                </JDText>
                <JDText
                  style={
                    item.disabled
                      ? [styles.goodsPriceNum, styles.soldOutColor]
                      : [styles.goodsPriceNum, styles.goodsPriceColor]
                  }
                >{`${item.skuPrice.substring(1)}`}</JDText>
              </>
            )}
          </View>
        </View>
      </View>
    </JDTouchable>
  );
  render() {
    const {
      store: {
        myCart,
        myFollow,
        myRecord,
        cartLoading,
        showRecordIcon,
        showCartIcon,
        showFollowIcon,
        addGoods,
        isLoadAll,
        isLoadRecordAll,
      },
    } = this.props;
    return (
      <View style={styles.wrap}>
        {Platform.OS !== 'web' ? (
          <>
            <TopNavigationBar isNormal={true} title="添加商品" />
            <TopNavigationBarPlaceholder />
          </>
        ) : null}
        <ScrollTabView
          tabBarPosition="top"
          style={{ flex: 1 }}
          initialPage={0}
          preLoad={false}
          //指定此属性，使得choseLabel组件被选中时展示
          tabIsComponent={true}
          renderTabBar={() => {
            return (
              //使用ScrollTabBar会出现抖动
              <DefaultTabBar
                style={{ height: getRpx(98), borderWidth: 0 }}
                tabStyle={{ height: getRpx(98) }}
                underlineStyle={{
                  height: 0,
                }}
              />
            );
          }}
          onChangeTab={this.onChangeTab}
        >
          <View
            tabLabel={
              <View style={styles.tab}>
                <JDText style={styles.tabText}>对比历史</JDText>
              </View>
            }
            chosenLabel={
              <View style={styles.tab}>
                <JDText style={[styles.tabText, styles.current]}>对比历史</JDText>
                <JDImage source={Images.contrast.curIcon} style={styles.curIcon}></JDImage>
              </View>
            }
          >
            {showRecordIcon ? (
              <JDTouchable onPress={this.handleRecordEmpty}>
                <TabConEmpty text={'您还没有要对比的商品哦'} />
              </JDTouchable>
            ) : (
              <FlatList
                style={styles.goodsList}
                data={myRecord}
                initialNumToRender={6}
                windowSize={7}
                // bounces={false}
                renderItem={this._renderItem}
                onEndReached={this._loadRecordData}
                onEndReachedThreshold={0.01}
                ListFooterComponent={() => {
                  return isLoadRecordAll ? (
                    <View
                      style={{
                        width: '100%',
                        flexDirection: 'row',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      <JDText style={{ color: '#bfbfbf', fontSize: getRpx(20) }}>暂无更多数据</JDText>
                    </View>
                  ) : (
                    <View
                      style={{
                        width: '100%',
                        flexDirection: 'row',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      <JDLoadingView size={20}></JDLoadingView>
                      <JDText style={{ color: '#bfbfbf', fontSize: getRpx(20), marginLeft: getRpx(10) }}>
                        加载中...
                      </JDText>
                    </View>
                  );
                }}
              />
            )}
          </View>
          <View
            tabLabel={
              <View style={styles.tab}>
                <JDText style={styles.tabText}>购物车</JDText>
              </View>
            }
            chosenLabel={
              <View style={styles.tab}>
                <JDText style={[styles.tabText, styles.current]}>购物车</JDText>
                <JDImage source={Images.contrast.curIcon} style={styles.curIcon}></JDImage>
              </View>
            }
          >
            {cartLoading ? (
              <View style={styles.loading}>
                <JDLoadingView></JDLoadingView>
              </View>
            ) : null}
            {showCartIcon ? (
              <JDTouchable onPress={this.handleCartEmpty}>
                <TabConEmpty text={'您还没有要对比的商品哦'} />
              </JDTouchable>
            ) : (
              <FlatList
                style={styles.goodsList}
                data={myCart}
                onEndReached={this._loadCartData}
                renderItem={this._renderItem}
              />
            )}
          </View>
          <View
            tabLabel={
              <View style={styles.tab}>
                <JDText style={styles.tabText}>我的关注</JDText>
              </View>
            }
            chosenLabel={
              <View style={styles.tab}>
                <JDText style={[styles.tabText, styles.current]}>我的关注</JDText>
                <JDImage source={Images.contrast.curIcon} style={styles.curIcon}></JDImage>
              </View>
            }
          >
            {showFollowIcon ? (
              <JDTouchable onPress={this.handleFollowEmpty}>
                <TabConEmpty text={'您还没有要对比的商品哦'} />
              </JDTouchable>
            ) : (
              <FlatList
                style={styles.goodsList}
                data={myFollow}
                initialNumToRender={6}
                windowSize={7}
                // bounces={false}
                renderItem={this._renderItem}
                onEndReached={this._loadFollowData}
                onEndReachedThreshold={0.01}
                ListFooterComponent={() => {
                  return isLoadAll ? (
                    <View
                      style={{
                        width: '100%',
                        flexDirection: 'row',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      <JDText style={{ color: '#bfbfbf', fontSize: getRpx(20) }}>暂无更多数据</JDText>
                    </View>
                  ) : (
                    <View
                      style={{
                        width: '100%',
                        flexDirection: 'row',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      <JDLoadingView size={20}></JDLoadingView>
                      <JDText style={{ color: '#bfbfbf', fontSize: getRpx(20), marginLeft: getRpx(10) }}>
                        加载中...
                      </JDText>
                    </View>
                  );
                }}
              />
            )}
          </View>
        </ScrollTabView>

        <LinearGradient
          colors={
            addGoods
              ? ['rgba(242,20,12,1)', 'rgba(242,39,12,1)', 'rgba(242,77,12,1)']
              : ['rgba(204,204,204,1)', 'rgba(204,204,204,1)', 'rgba(204,204,204,1)']
          }
          start={{ x: 0, y: 0 }}
          end={{ x: 1, y: 0 }}
          style={styles.addBtn}
        >
          <JDTouchable onPress={this.addGoods}>
            <View style={styles.addBtnBox}>
              <JDText style={styles.addBtnText}>立即添加</JDText>
            </View>
          </JDTouchable>
        </LinearGradient>
      </View>
    );
  }
}
const AddGoodsContrastPageOberver = observer(AddGoodsContrastPage);
const AddGoodsContrastPageOberverWapper = (props: IProps) => <AddGoodsContrastPageOberver {...props} store={store} />;
export default AddGoodsContrastPageOberverWapper;
